import { forwardRef, type Ref, type SVGProps } from "react";
const IconWhiteBalanceFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M20.65 16.06h-.91v1.75h1a1.44 1.44 0 0 0 .89-.23.83.83 0 0 0 .29-.69c-.05-.55-.46-.83-1.27-.83" />
    <path d="M29 6H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1M15.67 19H14l-.93-3.54q0-.18-.18-.78a9 9 0 0 1-.14-.79c0 .16-.07.43-.14.8s-.13.63-.17.78L11.52 19H9.86l-1.75-6.74h1.43l.88 3.67c.16.68.27 1.27.34 1.77 0-.18.06-.45.13-.82a7 7 0 0 1 .19-.85l1-3.77h1.38l1 3.77c0 .17.1.43.16.77s.12.65.15.9q0-.36.15-.9c.07-.36.13-.65.19-.87l.89-3.67h1.43Zm7-.52a2.94 2.94 0 0 1-1.84.52h-2.54v-6.74h2.13a4.1 4.1 0 0 1 2.13.41 1.4 1.4 0 0 1 .66 1.33 1.64 1.64 0 0 1-.29 1 1.18 1.18 0 0 1-.77.47 1.52 1.52 0 0 1 .94.54 1.65 1.65 0 0 1 .29 1 1.67 1.67 0 0 1-.68 1.46Z" />
    <path d="M21.45 14.74a.67.67 0 0 0 .26-.59.57.57 0 0 0-.29-.55 1.77 1.77 0 0 0-.91-.17h-.77v1.49h.85a1.6 1.6 0 0 0 .86-.18" />
  </svg>
);
const ForwardRef = forwardRef(IconWhiteBalanceFilledSVG);
ForwardRef.displayName = "IconWhiteBalanceFilled";
export { ForwardRef as IconWhiteBalanceFilled };
